<template>
  <Suspense>
    <QuoteList v-if="isListType" />
    <QuoteCalculation v-else />
  </Suspense>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import QuoteCalculation from "./components/QuoteCalculation.vue";
import QuoteList from "./components/QuoteList.vue";

const isListType = ref(false);

const quoteCalculationElement = document.getElementById("quote-calculation");
if (quoteCalculationElement) {
  const dataType = quoteCalculationElement.getAttribute("data-type");
  if (dataType === "list" || window.abList) {
    isListType.value = true;
  }
}
</script>
